export const PRIMARY_SOURCE = 'iLWebsite';
export const SECONDARY_SOURCE = 'Digital';
export const UNIDENTIFIED_SOURCE = 'Unidentified';
